"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("styled-components/macro");

var _cardValidator = _interopRequireDefault(require("card-validator"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _Inputs = require("../styles/Inputs.styles");

var _ = require("../../");

var _svg = require("../../svg/");

var _Label = _interopRequireDefault(require("./Label"));

var _Errors = _interopRequireDefault(require("./Errors"));

var _validateInput = _interopRequireDefault(require("../validations/validateInput"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var creditCards = {
  default: _svg.CreditCardPlaceHolder,
  visa: _svg.Visa,
  mastercard: _svg.MasterCard,
  maestro: _svg.MasterCard,
  'american-express': _svg.Amex,
  'diners-club': _svg.Diners,
  discover: _svg.Discover,
  jcb: _svg.Jcb,
  unionpay: _svg.CreditCardPlaceHolder,
  mir: _svg.CreditCardPlaceHolder,
  elo: _svg.CreditCardPlaceHolder,
  hiper: _svg.CreditCardPlaceHolder,
  hipercard: _svg.CreditCardPlaceHolder,
  error: _svg.WrongCard
};

var CreditCard = function CreditCard(_ref) {
  var _ref$codeFields = _ref.codeFields,
      codeFields = _ref$codeFields === void 0 ? 4 : _ref$codeFields,
      id = _ref.id,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      validations = _ref.validations,
      onChange = _ref.onChange,
      dependencies = _ref.dependencies,
      isFirstInput = _ref.isFirstInput,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      t = _ref.t,
      validationDependency = _ref.validationDependency,
      errorHandler = _ref.errorHandler,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      customLabel = _ref.customLabel,
      noFocus = _ref.noFocus,
      postErrors = _ref.postErrors,
      postErrorHandler = _ref.postErrorHandler,
      fieldDescription = _ref.fieldDescription,
      labelTooltip = _ref.labelTooltip;
  var codeRefs = Array.from(Array(codeFields).keys()).map(function () {
    return (0, _react.createRef)();
  });

  var _useState = (0, _react.useState)(['', '', '', '']),
      _useState2 = _slicedToArray(_useState, 2),
      splittedValue = _useState2[0],
      setSplittedValue = _useState2[1];

  var _useState3 = (0, _react.useState)('default'),
      _useState4 = _slicedToArray(_useState3, 2),
      cardType = _useState4[0],
      setCardType = _useState4[1];

  var validationDepKey, validationDepValue;

  if (validationDependency) {
    var _Object$values$;

    validationDepKey = Object.keys(validationDependency)[0];
    validationDepValue = (_Object$values$ = Object.values(validationDependency)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.toString();
  }

  var validationsArray = dependencies && dependencies[validationDepKey] && dependencies[validationDepKey][validationDepValue] ? !value && [].concat(_toConsumableArray(dependencies[validationDepKey][validationDepValue]), _toConsumableArray(validations || [])) : validations;

  var getRealValue = function getRealValue() {
    var realValue = '';
    codeRefs.forEach(function (ref) {
      return realValue += ref.current.value;
    });
    return realValue;
  };

  var inputChangeHandler = function inputChangeHandler() {
    var valueUpdate = getRealValue();

    if (valueUpdate.length <= 16) {
      if (postErrors) {
        postErrorHandler(id);
      }

      onChange(id, valueUpdate);
    }
  };

  var inputValidation = function inputValidation(valueToCheck) {
    (0, _validateInput.default)({
      value: valueToCheck,
      validations: validationsArray,
      validationDependency: validationDepValue,
      errorHandler: errorHandler,
      dependencies: dependencies,
      id: id
    });
  };

  var onKeyDownHandler = function onKeyDownHandler(e) {
    var invalidChars = [69, 187, 189, 188, 190, 229];
    if (invalidChars.includes(e.keyCode)) e.preventDefault();

    if (e.keyCode === 8) {
      var realValueLength = getRealValue().length;
      if (realValueLength <= 4) codeRefs[0].current.focus();
      if (realValueLength > 4 && realValueLength <= 8) codeRefs[1].current.focus();
      if (realValueLength > 8 && realValueLength <= 12) codeRefs[2].current.focus();
      if (realValueLength > 12) codeRefs[3].current.focus();
    } else {
      if (value.length === 4) codeRefs[1].current.focus();
      if (value.length === 8) codeRefs[2].current.focus();
      if (value.length === 12) codeRefs[3].current.focus();
    }
  };

  (0, _react.useEffect)(function () {
    if (validationsArray) {
      inputValidation(value);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  (0, _react.useEffect)(function () {
    if (dependencies) inputValidation(value); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validationDepValue]);
  (0, _react.useEffect)(function () {
    if (isFirstInput && !noFocus) codeRefs[0].current.focus(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    var cardDetail = _cardValidator.default.number(value);

    if (cardDetail.card) setCardType(cardDetail.card.type);else if (cardDetail.isPotentiallyValid) setCardType('default');else setCardType('error');
  }, [value]);
  (0, _react.useEffect)(function () {
    if (value) {
      var splitted = _toConsumableArray(splittedValue);

      var _splittedValueUpdate = value.match(/.{1,4}/g);

      splitted.forEach(function (val, i) {
        return splitted[i] = _splittedValueUpdate[i] || '';
      });
      setSplittedValue(splitted);
    } else setSplittedValue(['', '', '', '']); // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  return _react.default.createElement(_react.Fragment, null, customLabel && _react.default.createElement(_Label.default, {
    customLabel: customLabel,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), _react.default.createElement(_.FlexContainer, {
    alignItems: "center"
  }, splittedValue.map(function (input, i) {
    return _react.default.createElement(_Inputs.InputBlock, {
      type: "number",
      disableUnderline: true,
      inputRef: codeRefs[i],
      width: "".concat(90 / splittedValue.length, "%"),
      key: i,
      disabled: disabled,
      value: splittedValue[i],
      onInput: function onInput(e) {
        return inputChangeHandler(i, e);
      },
      onKeyDown: onKeyDownHandler
    });
  }), _react.default.createElement(_Inputs.CardDiv, null, _react.default.createElement(creditCards[cardType], {
    size: 32,
    extraCss: 'height: 32px'
  }))), _react.default.createElement(_Errors.default, {
    errors: postErrors ? [].concat(_toConsumableArray(errors), [postErrors.message]) : errors,
    t: t
  }));
};

var _default = _react.default.memo(CreditCard, _isEqual.default);

exports.default = _default;